const ListBlogPostsText = ({
  posts,
  posted_by,
  posted_by_slug,
  posted_by_type,
}) => {
  const postUrl = `/music/${posted_by_slug}/blog/`;

  const getPostedByUrl = (slug, type) => {
    const normalizedType = String(type || "").toLowerCase();
    const basePath = ["organizer", "organiser", "organization"].includes(
      normalizedType,
    )
      ? "/orgs"
      : "/music";

    return slug ? `${basePath}/${slug}` : basePath;
  };

  const fixedPostedByUrl = getPostedByUrl(posted_by_slug, posted_by_type);

  return (
    <>
      {posts.map((post, index) => (
        <div
          key={index}
          className="bg-[#131313] border border-white/10 rounded-2xl min-h-[5rem] my-2.5 p-4 px-5 flex flex-col justify-center shadow-md hover:border-white/20 transition-all duration-300 hover:scale-[1.01]"
        >
          <div className="flex items-start justify-between gap-3 mb-3">
            <a
              href={postUrl + post.slug}
              className="font-extrabold text-sm sm:text-base text-white uppercase tracking-wide overflow-hidden line-clamp-2 hover:text-[#0047ff] transition-colors"
            >
              {post.title}
            </a>
            <a
              href={`/search?post_type=${post.post_type.toLowerCase()}`}
              className="shrink-0 inline-flex items-center px-2.5 py-1 rounded-full bg-[#0047ff]/10 text-[#0047ff] text-[9px] font-black tracking-wider uppercase border border-[#0047ff]/20"
            >
              {post.post_type}
            </a>
          </div>

          <div className="flex flex-wrap items-center justify-between gap-2 mt-auto pt-2.5 border-t border-white/5">
            <p className="text-[10px] text-stone-400">
              Av:{" "}
              <a
                className="font-bold text-white hover:text-[#0047ff] transition-colors"
                href={
                  posted_by_slug
                    ? fixedPostedByUrl
                    : getPostedByUrl(post.posted_by_slug, post.posted_by_type)
                }
              >
                {posted_by ? posted_by : post.posted_by_name}
              </a>
            </p>
            <p className="text-[10px] text-stone-500 font-semibold">{post.created_at}</p>
          </div>
        </div>
      ))}
    </>
  );
};

export default ListBlogPostsText;
